var oPreview = {
  init: function () {
    $("body").on("click", ".imgPreview", function () {
      var src = $(this).attr("src"),
        postId = $(this).attr("post-id");
      console.log("src", src);

      console.log("postId", postId);
      $(".galleryPreviewContainer[post-id=" + postId + "]").toggleClass(
        "hidden"
      );
      $(".galleryPreviewImg[post-id=" + postId + "]").attr("src", src);
    });

    $("body").on("click", ".galleryPreviewClose", function () {
      var postId = $(this).attr("post-id");
      $(".galleryPreviewContainer[post-id=" + postId + "]").toggleClass(
        "hidden"
      );
    });
  },
};

var oPost = {
  sel: {
    initPoint: ".start-load",
    postsContainer: ".async__posts",
    progressBar: ".progressBar",
    postBody: ".postBodyFlag",
  },

  options: {
    queryEnded: false,
    firstQueryEnded: false,
    currentPostId: "#initPostId",
    initPostCategory: "#initPostCategory",
    initPostLink: "#initPostLink",
    nextPostId: null,
    iterationCounter: 0,
    currentInViewport: null,
    wasInViewport: null,
    scrolled: false,
  },

  routes: {
    test: "/wp-json/",
    postById: "/wp-json/wp/v2/posts/",
  },

  urls: {},

  init: function () {
    console.log("init!");
    oPost.options.currentInViewport = $(oPost.options.currentPostId).val();

    $(window).scroll(function () {
      setTimeout(oPost.moveProgressBar(oPost.options.currentInViewport), 1);

      if ($.active > 0) {
        return true;
      } else {
        !oPost.options.firstQueryEnded
          ? oPost.checkBrakepoint($(oPost.options.currentPostId).val())
          : oPost.checkBrakepoint(oPost.options.currentPostId);
      }

      oPost
        .asyncFunction()
        .done(function () {
          oPost.checkViewport();
        })
        .fail(function () {
          console.log("oPost.checkViewport() Failed!");
        });
    });
  },

  checkBrakepoint: function (postId) {
    var initItem = $(oPost.sel.initPoint).offset().top,
      offset = initItem - $(window).scrollTop();

    if (2500 > offset && oPost.options.iterationCounter <= 2) {
      oPost.getPreviousPost(postId);
    }
  },

  getPreviousPost: function (postId) {
    $.ajax({
      method: "GET",
      url: oPost.routes.postById + postId,
      data: {
        scroll: "true",
        categories_exclude: "23",
      },
    })
      .done(function (response) {
        $(oPost.options.initPostLink).attr(
          "href",
          "#post__container__" + response.previous.id
        );
        oPost.urls[response.id] = response.link;

        response.previous != "" && response.previous != "undefined"
          ? (oPost.options.nextPostId = response.previous.id)
          : null;
        response.previous != "" && response.previous != "undefined"
          ? oPost.nextPostById(oPost.options.nextPostId)
          : false;
      })
      .fail(function (response) {
        console.log("Something went wrong...");
      });
  },

  nextPostById: function (postId) {
    $.ajax({
      method: "GET",
      url: oPost.routes.postById + postId,
      data: {
        scroll: "true",
        categories_exclude: "23",
      },
    })
      .done(function (response) {
        if (response != "" && response != "undefined") {
          oPost.createPost(response.id, response.link);
        }
      })
      .fail(function (response) {
        console.log("Something went wrong...");
      });
  },

  createPost: function (id, url) {
    $.ajax({
      url: url,
      cache: false,
      success: function (response) {
        var parsed = $.parseHTML(response),
          post = $(parsed).filter("#post__container__" + id),
          newPostContainer = $("<div>"),
          loaderInit = $("<div>"),
          commentContainer = $("<div>"),
          commentWrapper = $("<div>"),
          redirectForm = $("<form>");
        (commentLink = $("<button>")), (hiddenInput = $("<input>"));

        $(newPostContainer).addClass("post__container__" + id);

        $(newPostContainer).attr("id", "post__container__" + id);

        $(loaderInit).addClass("start-load").attr("post-id", id);

        $(commentContainer).addClass(
          "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4 mb-8"
        );

        $(commentWrapper).addClass("grid grid-cols-3 slideToNextButton");
        $(redirectForm).addClass("block col-span-3 lg:col-span-2");

        // $(commentLink)
        //   .css("height", "80px")
        //   .css("width", "100%")
        //   .css("display", "block");
        // $(commentLink).addClass("redirectToComment");

        // $(commentLink).attr("type", "submit").text("ZOBACZ KOMENTARZE");

        $(hiddenInput)
          .attr("name", "redirect")
          .attr("value", url + "#disqus_thread")
          .attr("hidden", "hidden");

        $(commentContainer).append(commentWrapper);

        $(redirectForm).attr("method", "POST");
        $(commentWrapper).append(redirectForm);
        $(redirectForm).append(hiddenInput);

        $(newPostContainer)
          .append(post[0])
          .append(commentContainer)
          .append(loaderInit);

        $(oPost.sel.postsContainer).append(newPostContainer);

        $(newPostContainer).addClass("top__padding");

        oPost.urls[id] = url;
        oPost.sel.initPoint = '.start-load[post-id="' + id + '"]';
        oPost.options.currentPostId = id;
        oPost.options.firstQueryEnded = true;
        oPost.options.iterationCounter++;

        // Reinit modules
        oPreview.init();
      },
    });
  },
  checkViewport: function () {
    $(oPost.sel.postBody).each(function () {
      if (oPost.isInViewport(this)) {
        oPost.options.currentInViewport = this.getAttribute("post-data");

        var thisBind = this.getAttribute("post-data");

        if (oPost.options.currentInViewport != oPost.options.wasInViewport) {
          oPost.changeLink(oPost.urls[thisBind]);

          oPost.options.wasInViewport = this.getAttribute("post-data");
        }
      }
    });
  },
  isInViewport: function (post) {
    var win = $(window),
      viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft(),
      };

    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = $(post).offset();
    bounds.right = bounds.left + $(post).outerWidth();
    bounds.bottom = bounds.top + $(post).outerHeight();

    return !(
      viewport.right < bounds.left ||
      viewport.left > bounds.right ||
      viewport.bottom < bounds.top ||
      viewport.top > bounds.bottom
    );
  },

  moveProgressBar: function (id) {
    var selector = "#post__container__" + id,
      scrollPercent =
        (100 * ($(window).scrollTop() - $(selector).offset().top)) /
        $(selector).height();

    $(oPost.sel.progressBar).css("width", Math.ceil(scrollPercent) + "%");
  },

  changeLink: function (url) {
    window.history.replaceState(null, null, url);
  },

  asyncFunction: function () {
    var deferred = $.Deferred();

    setTimeout(function () {
      deferred.resolve();

      deferred.reject();
    }, 1);

    return deferred;
  },
};

$(document).ready(function () {
  if ($("#mod").val() == "single-post" && $("#isPreview").val() != "true") {
    console.log("HERE!");
    oPost.init();
    oPreview.init();
  }
});
